enum Status {
  DUE = 'due',
  PENDING = 'pending',
  COMPLETED = 'completed',
}

export { Status }
